export default {
	items: [
		{
			id: 'navigation',
			title: '',
			type: 'group',
			icon: 'icon-navigation',
			children: [
				{
					id: 'dashboard',
					title: 'Dashboard',
					type: 'item',
					url: '/admin/dashboard/home',
					icon: 'feather icon-box',
				},
				{
					id: 'property',
					title: 'Properties',
					type: 'item',
					url: '/admin/dashboard/properties',
					icon: 'feather icon-home',
				},
				{
					id: 'inspection',
					title: 'Inspection Entries',
					type: 'item',
					url: '/admin/dashboard/inspection-entries',
					icon: 'feather icon-user',
				},
				{
					id: 'contact',
					title: 'Contact Us Entries',
					type: 'item',
					url: '/admin/dashboard/contact-entries',
					icon: 'feather icon-bell',
				},
			],
		},
	],
}
